import Clipboard from 'clipboard'
global.Clipboard = Clipboard

document.addEventListener("turbolinks:load", function() {
  var clipboard = new Clipboard('.clipboard-btn');
  var clipboard = new Clipboard('.clipboard-modal', {
    container: document.getElementById('modal')
});

  $('.clipboard-btn').tooltip({
    trigger: 'click',
    placement: 'top'
  });

  function setTooltip(btn, message) {
    $(btn).tooltip('show')
      .attr('data-original-title', message)
      .tooltip('show');
  }

  function hideTooltip(btn) {
    setTimeout(function() {
      $(btn).tooltip('hide')
      .attr('data-original-title', 'Copy to clipboard');
    }, 1000);
  }

  clipboard.on('success', function(e) {
    setTooltip(e.trigger, 'Copied!');
    hideTooltip(e.trigger);
  });

  clipboard.on('error', function(e) {
    setTooltip(e.trigger, 'Failed!');
    hideTooltip(e.trigger);
  });

  $('#images_modal').on('show.bs.modal', function (event) {
    var img = $(event.relatedTarget)
    var img_src = img.attr('src')
    var modal = $(this)
    modal.find('.modal-body img').attr('src', img_src)
  });
})
